import { Phone } from "lucide-react";

const CallFab = () => (
  <a
    href="tel:0490425408"
    data-testid="mobile-call-button"
    aria-label="Call Derek now"
    className="fixed bottom-6 right-6 z-[60] flex h-16 w-16 items-center justify-center rounded-full bg-copper text-ink shadow-[0_0_24px_rgba(200,146,90,0.5)] md:hidden"
  >
    <span className="absolute inset-0 rounded-full bg-copper animate-pulse-ring" aria-hidden="true" />
    <Phone className="relative h-6 w-6" strokeWidth={1.75} />
  </a>
);

export default CallFab;
